import axios from 'axios';
import Globals from '../Globals';
import { getLogModel, toIsoDateOnly } from '../Functions';
import LoggingService from './LoggingService';
axios.defaults.timeout = 120000;
class ContractsService {
    base_url = Globals.BFF_PATH.BASE_URL + '/ContractsService';
    readScoringMatrix = async (token, DealerCodeVWFS) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({ DealerCodeVWFS: DealerCodeVWFS }),
        };

        return await axios
            .post(
                this.base_url + Globals.BFF_PATH.CONTRACT.GET_MATRIX_RENTING,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readRentingExpirationList = async (
        token,
        DealerCodeVWFS,
        MatrixContracts,
        FiltersApplied
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            DealerCodeVWFS: DealerCodeVWFS,
            CustomerVehicleCategory: MatrixContracts,
        };
        if (
            FiltersApplied !== null &&
            FiltersApplied !== undefined &&
            FiltersApplied.length > 0
        ) {
            FiltersApplied.forEach(function (item) {
                jsonToSend[item.filterServiceName] = item.value;
            });
        }
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.CONTRACT.GET_RENTING_EXPIRATION,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readRentingExpirationListExcel = async (
        token,
        DealerCodeVWFS,
        MatrixContracts,
        FiltersApplied,
        ExportOptions = {}
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            DealerCodeVWFS: DealerCodeVWFS,
            CustomerVehicleCategory: MatrixContracts,
        };
        if (
            FiltersApplied !== null &&
            FiltersApplied !== undefined &&
            FiltersApplied.length > 0
        ) {
            FiltersApplied.forEach(function (item) {
                jsonToSend[item.filterServiceName] = item.value;
            });
        }
        jsonToSend = {
            ...jsonToSend,
            ...ExportOptions,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.CONTRACT.GET_RENTING_EXPIRATION_EXCEL,
                data,
                config
            )
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readServiceVehicle = async (token, VehicleId) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({ VehicleId: VehicleId }),
        };

        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.CONTRACT.GET_RENTING_INFORMATION_VEHICLE,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readServiceContract = async (token, User, FinantialOperation) => {
        //FinantialOperation  string  new servi
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: User,
            OperationCode: FinantialOperation,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },

            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(
                this.base_url + '/get-ws-renting-information-contract',
                data,
                config
            ) //nuevo serv end point
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readServiceClient = async (token, User, FinantialOperation) => {
        //ClientId  decimal new servi
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: User,
            OperationCode: FinantialOperation,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(
                this.base_url + '/get-ws-renting-information-client',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readRentinClienteList = async (token, FinantialOperation) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({ FinantialOperation: FinantialOperation }),
        };

        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.CONTRACT.GET_RENTING_CLIENT_LIST,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readActionsDecisionstypeList = async (token, User, opt) => {
        //get type add actividad
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        //cuando el tipo de producto es cpc next  TipoProductoRentingCPC -> 'C', renting TipoProductoRentingCPC-> 'R'
        //cuando el tipo de producto es cpc next  TiposPantalla -> '01,17', renting TiposPantalla-> '08,17'
        let jsonToSend = {
            Usuario: User,
            TipoProductoRentingCPC: opt ? 'R' : 'C',
            EsTerminacionesPerito: 0,
            EsTerminaciones: 0,
            EsVistaConcesionario: 1,
            TipoAccion: 'A',
            TiposPantalla: opt ? '08,17' : '01,17',
            TextoMotivo: 'Motivo',
            TextoObservacion: 'Observacion ',
            TextoAccion: 'Accion',
            TextoDecision: 'Decision',
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(this.base_url + '/get-list-decisions-user', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readActionsDecisionsList = async (token, User, FinantialOperation) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        let jsonToSend = {
            Usuario: User,
            OperacionFinanciera: FinantialOperation,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/get-datos-decisiones', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    addActionsDecisionsService = async (
        token,
        User,
        TipoDeDecision,
        ObservacionesDecision,
        FechaAltaBD,
        IdPoliza
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        let jsonToSend = {
            Usuario: User,
            TipoDeDecision: TipoDeDecision,
            ObservacionesDecision: ObservacionesDecision,
            PeritoAsignado: FechaAltaBD,
            IdPoliza: IdPoliza,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/insert-datos-decisiones', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    addActionUserDecisionService = async (
        token,
        User,
        FinantialOperation,
        ConstanteLog,
        IDENTIFICADORUNICO,
        DetallesOperacion
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        let jsonToSend = {
            UsuarioId: User,
            OperacionFinanciera: FinantialOperation,
            ConstanteLog: ConstanteLog,
            IDENTIFICADORUNICO: IDENTIFICADORUNICO,
            DetallesOperacion: DetallesOperacion,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/insert-actions-decisiones', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    readUUIDDecisionesService = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify([]),
        };
        return await axios
            .post(this.base_url + '/get-UUID-decisiones', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    readDateScoringMatrix = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(this.base_url + '/get-last-fileDate-scoring', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readInformationVehiclesEconomical = async (
        token,
        User,
        FinantialOperation
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: User,
            OperationCode: FinantialOperation,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(
                this.base_url + '/get-ws-renting-information-economical',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    readInformationBonding = async (token, User, FinantialOperation) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: User,
            OperationCode: FinantialOperation,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(
                this.base_url + '/get-ws-renting-information-aditional-poducts',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readVehicleContract = async (token, User, FinantialOperation) => {
        //FinantialOperation  string  new servi
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: User,
            OperationCode: FinantialOperation,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(
                this.base_url + '/get-ws-renting-vehicles-contract',
                data,
                config
            ) //nuevo serv end point
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readInformationProyeccion = async (
        token,
        User,
        FinantialOperation,
        DeealerCodeVWFS,
        typeProyeccion,
        IPODate
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: User,
            OperationCode: FinantialOperation,
            DealerCodeVWFS: DeealerCodeVWFS,
            IsNext: typeProyeccion,
            IPODate: toIsoDateOnly(IPODate)
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(
                this.base_url + '/get-ws-next-proyection-contract',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    newSimulacionLPA = async (
        token,
        User,
        FinantialOperation,
        CancellationDate,
        ClientRequest
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: User,
            OperationCode: FinantialOperation,
            CancellationDate: CancellationDate,
            ClientRequest: ClientRequest,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/get-ws-settlementV2-lpa', data, config) //get-ws-settlement-lpa
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    listSimulacionLPA = async (token, FinantialOperation) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            OperationCode: FinantialOperation,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(this.base_url + '/get-list-lpa-by-operation', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    simulacionLPAIDResult = async (token, id) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            LPAId: id,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/get-lpa-by-id', data, config) //get-ws-settlement-lpa
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getCertificateLPA = async (
        token,
        User,
        DNICliente,
        FinantialOperation,
        FechaCalculo,
        Email
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        let jsonToSend = {
            UserRequest: User,
            UserID: DNICliente,
            CancellationDate: FechaCalculo,
            Email: Email,
            OperationCode: FinantialOperation,
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/get-certificate-lpa', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    //metricas huertos
    getMetricaPLA = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(this.base_url + '/get-metrica-lpa', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    getMetricaAccesoVendedor = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(this.base_url + '/get-metrica-accesoVendedor', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    getMetricaAccesoConcesionarios = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(
                this.base_url + '/get-metrica-accesoConcesionarios',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getMetricaActividadDecision = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(
                this.base_url + '/get-metrica-actividadDecision',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getMetricasAccionesUSR = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(this.base_url + '/get-metrica-AccionesUSR', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    getConceptologToMetricas = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(this.base_url + '/get-conceptoslog-metrica', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    getAsignacionVolumenVendedorToMetricas = async (
        token,
        fechasDesde,
        fechaHasta
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        let jsonToSend = {
            //dkxewh5
            ExpirationDateFrom: fechasDesde,
            ExpirationDateTo: fechaHasta,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(
                this.base_url + '/get-asignacionVolumenVendedor-metrica',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    ReadAsignacionVolumenVendedorToMetricasToConcesionarios = async (
        token,
        DealerCodeVWFS
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({ DealerCodeVWFS: DealerCodeVWFS }),
        };
        return await axios
            .post(
                this.base_url +
                    '/get-asignacionVolumenVendedorMetricas-Concesioanrio',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    getTextoLanding = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(this.base_url + '/get-texto-landing', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    updateTextoLanding = async (token, User, textoLanding) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                UserRequest: User,
                Email: textoLanding,
            }),
        };
        return await axios
            .post(this.base_url + '/update-texto-landing', data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readListPerfilesAsignacionVolumenVendedor = async (
        token,
        DealerCodeVWFS
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                DealerCodeVWFS: DealerCodeVWFS,
            }),
        };
        return await axios
            .post(
                this.base_url + '/readList-perfil-asignacionVolumenVendedor',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readRentingExpirationListAsignados = async (
        token,
        DealerCodeVWFS,
        UsuarioVendedorAsignado
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            DealerCodeVWFS: DealerCodeVWFS,
            UsuarioVendedorAsignado: UsuarioVendedorAsignado,
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.CONTRACT.GET_RENTING_EXPIRATION_ASIGNADOS,
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    readRentingExpirationListAsignadosExcel = async (
        token,
        DealerCodeVWFS,
        UsuarioVendedorAsignado,
        ExportOptions = {}
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            DealerCodeVWFS: DealerCodeVWFS,
            UsuarioVendedorAsignado: UsuarioVendedorAsignado,
            ...ExportOptions,
        };

        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };

        return await axios
            .post(
                this.base_url +
                    Globals.BFF_PATH.CONTRACT
                        .GET_RENTING_EXPIRATION_ASIGNADOS_EXCEL,
                data,
                config
            )
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    AsignacionVolumenVendedor = async (
        token,
        USERID,
        POCIDPOLIZA,
        USERIDVENDEDOR,
        dealerCodeVWF,
        autoasignado
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                USERID: USERID,
                USERIDVENDEDOR: USERIDVENDEDOR,
                POCIDPOLIZA: POCIDPOLIZA,
                dealerCodeVWF: dealerCodeVWF,
                autoAsignado: autoasignado,
            }),
        };
        return await axios
            .post(
                this.base_url + '/insert-AsignacionVolumenVendedor',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    UpdateFavoritoSelect = async (token, POYINDESFAVORITO, POCIDPOLIZA) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                POYINDESFAVORITO: POYINDESFAVORITO,
                POCIDPOLIZA: POCIDPOLIZA,
            }),
        };
        return await axios
            .post(
                this.base_url + '/update-FavoritoAsignacionVendedor',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
    ReadDiasAlertaVencimientoToProducto = async token => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({}),
        };
        return await axios
            .post(
                this.base_url + '/get-diasAlerta-vencimiento-producto',
                data,
                config
            )
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    cargarContratosCliente = async (token, DealerCode, NIF) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                cod_concesion: DealerCode,
                cod_usuario: NIF,
            }),
        };
        return await axios
            .post(this.base_url + '/get-dealer-validation', data, config) //get-lpo
            .then(response => {
                console.log(response);
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                console.log(error);
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    cargarContratosPropios = async (token, DealerCode) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(),
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify({
                cod_concesion: DealerCode,
            }),
        };
        return await axios
            .post(this.base_url + '/get-own-dealer-contracts', data, config) //get-lpo
            .then(response => {
                console.log(response);
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                console.log(error);
                if (error && error.config && error.response) {
                    var newError = getLogModel(
                        Globals.ERROR_LOG_ID,
                        error.config.url,
                        config,
                        data,
                        error
                    );
                    new LoggingService().createLog(newError);
                }
            });
    };

    newSeleccionLPO = async (token, user, operationCode, lpoDate) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: user,
            OperationCode: operationCode,
            CancellationDate: lpoDate,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/new-seleccion-lpo', data, config)
            .then(response => {
                console.log(response);
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                console.log(error);
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };

    simulacionLPO = async (token, user, operationCode, lpoDate, vehicles) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        let jsonToSend = {
            UserRequest: user,
            OperationCode: operationCode,
            CancellationDate: lpoDate,
            SelectedVehicles: vehicles,
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(jsonToSend),
        };
        return await axios
            .post(this.base_url + '/new-Settlements-LPO', data, config) //get-ws-settlement-lpa
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                    return response.data;
                }
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(newError);
            });
    };
}
export default ContractsService;
